import { NgForm } from '@angular/forms';

export const MOCK_NG_FORM: NgForm = new NgForm(null, null);
